import { useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { Button, DialogContent, DialogContentText, Stack } from '@mui/material';

import { useDialog } from 'hooks/useDialog';
import { dialogPropsSelector } from 'store/entities/ui/slice';
import { Input } from 'components/simple';
import { Dialog } from 'components/complex';

const defaultValues = {
  name: '',
};

export const SaveCreatedMasterDashboardDialog = () => {
  const { id, onConfirm, apiError, resetError } = useSelector(dialogPropsSelector);
  const { closeDialog } = useDialog();
  const {
    handleSubmit,
    control,
    formState: { isValid, isSubmitting },
  } = useForm({ defaultValues });

  return (
    <Dialog withCustomContent id={id} title="Save Master Dashboard" isLoading={isSubmitting}>
      <DialogContent>
        <DialogContentText id={`${id}-description`} variant="body2" color="text.primary" mb={4}>
          Please name the Master dashboard
        </DialogContentText>

        <Stack component="form" onSubmit={handleSubmit(onConfirm)} spacing={4}>
          <Controller
            name="name"
            rules={{
              required: 'Please enter master dashboard name',
              minLength: 2,
            }}
            control={control}
            render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => {
              const fieldError = apiError ? { message: apiError } : error;

              return (
                <Input
                  {...field}
                  autoFocus
                  withHiddenLabel
                  inputProps={{ maxLength: 100 }}
                  id={`${id}-name`}
                  innerRef={ref}
                  error={fieldError}
                  label="Please name the Master dashboard"
                  placeholder="Enter dashboard name"
                  onChange={(value) => {
                    resetError();
                    onChange(value);
                  }}
                />
              );
            }}
          />

          <Stack direction="row" spacing={2}>
            <Button onClick={closeDialog} color="secondary" disabled={isSubmitting}>
              Cancel
            </Button>

            <Button type="submit" disabled={!isValid} loading={isSubmitting}>
              Save
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
